import React from "react"


import FieldTaskAssignedToUser from "../assigned-to-user";
import FieldProto_ConditionForm from "../../../../../proto/render/condition/condition-form";
import ConditionTypeSelector from "../../../../../proto/render/condition/condition-type-selector";
import SelectMultiGenericNew from "../../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new";
import FieldUser_MultiselectValueNotEmpty from "../../../../../generic/user/components/multiselect/value-not-empty";
import FieldUser_MultiselectPopoverOption from "../../../../../generic/user/components/multiselect/popover-option";

const debug = false
// const debug = "FieldTaskAssignedToUser_ConditionForm"

export default class FieldTaskAssignedToUser_ConditionForm extends FieldProto_ConditionForm {

    render() {
        debug && console.log(debug, 'render', this.state)

        // we need "Not assigned option here...
        const options:Option[] = this.props.field.getOptions()

        options.unshift({
            value   : null,
            label   : 'Not assigned'
        })

        return (
            <React.Fragment>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                       options                          = {options}
                                       values                           = {this.props.condition.value}
                                       popoverScrollContainerClasses    = "max-h-200 max-w-200"
                                       valueComponent                   = {FieldUser_MultiselectValueNotEmpty}
                                       popoverOptionComponent           = {FieldUser_MultiselectPopoverOption}
                                       isSearchable                     = {true}
                                       // disabled                         = {disabled}
                                       onChange                         = {this.onChangeValue}/>
            </React.Fragment>
        )
    }
}